import Vue from 'vue'
import Router from 'vue-router'
import AdminSignin from '@/components/AdminSignin'
import Home from '@/components/Home'
import MemoSet from '@/components/MemoSet'
import MemoSets from '@/components/MemoSets'
import PublicMemoSets from '@/components/PublicMemoSets'
import SharedMemoSets from '@/components/SharedMemoSets'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    }, {
      path: '/index.html',
      name: 'HomeIndex',
      component: Home
    }, {
      path: '/admin-signin',
      name: 'AdminSignin',
      component: AdminSignin
    }, {
      path: '/memo-sets/:memoSetId/:slug',
      name: 'MemoSet',
      component: MemoSet
    }, {
      path: '/memo-sets',
      name: 'MemoSets',
      component: MemoSets
    }, {
      path: '/public-memo-sets/:memoSetId/:slug',
      name: 'PublicMemoSet',
      component: MemoSet
    }, {
      path: '/public-memo-sets',
      name: 'PublicMemoSets',
      component: PublicMemoSets
    }, {
      path: '/shared-memo-sets/:memoSetId/:slug',
      name: 'SharedMemoSet',
      component: MemoSet
    }, {
      path: '/shared-memo-sets',
      name: 'SharedMemoSets',
      component: SharedMemoSets
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js